import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import store from './store'
import router from './router'
import '@/custom-component' // 注册自定义组件
import '@/assets/iconfont/iconfont.css'
import '@/styles/animate.scss'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/reset.css'
import '@/styles/global.scss'
import http from './utils/http'
import localForage from 'localforage'
import i18n from './locales/i18n' // ✅ 引入你刚刚写的 i18n
Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$forage = localForage



new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
})
